import React, { useEffect, useState } from "react";
import axios from "axios";
import classNames from "classnames";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-kit-pro-react/views/ecommerceSections/blogStyle.js";

const useStyles = makeStyles(styles);

// Yardımcı fonksiyon: İlk <p>'den ilk 2 cümleyi al
const extractFirstTwoSentencesOfFirstParagraph = (html) => {
  const match = html.match(/<p[^>]*>(.*?)<\/p>/i);
  if (!match) return "";

  const paragraph = match[1].replace(/(<([^>]+)>)/gi, "").trim();
  const sentences = paragraph.split(/(?<=[.!?])\s+/).slice(0, 2).join(" ");
  return `<p>${sentences}</p>`;
};

export default function SectionBlog() {
  const classes = useStyles();
  const [blogPosts, setBlogPosts] = useState([]);

  useEffect(() => {
    axios
      .get("https://ecommerce24.pythonanywhere.com/api/blog/")
      .then((res) => {
        const firstThree = res.data.slice(0, 3);
        setBlogPosts(firstThree);
      })
      .catch((err) => console.error("Blog API hatası: ", err));
  }, []);

  return (
    <div className={classes.section}>
      <div className={classes.container}>
        <h2 className={classes.sectionTitle}>Son Yazılar</h2>
        <GridContainer>
          {blogPosts.map((post, index) => (
            <GridItem
              md={4}
              sm={4}
              key={index}
              style={{ display: "flex" }} // Kartları aynı hizada tut
            >
              <Card
                blog
                style={{
                  display: "flex",
                  flexDirection: "column",
                  flexGrow: 1,
                }}
              >
                <CardHeader image>
                  <a href={`/blog-posts/${post.slug}`}>
                    <img src={post.cover_image} alt={post.title} />
                  </a>
                  <div
                    className={classes.coloredShadow}
                    style={{
                      backgroundImage: `url(${post.cover_image})`,
                      opacity: 1,
                    }}
                  />
                </CardHeader>

                <CardBody
                  style={{
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <h6
                    className={classNames(
                      classes.cardCategory,
                      classes.textRose
                    )}
                  >
                    Blog
                  </h6>
                  <h4 className={classes.cardTitle}>
                    <a href={`/blog-posts/${post.slug}`}>{post.title}</a>
                  </h4>

                  <div
                    className={classes.cardDescription}
                    style={{
                      fontSize: "14px",
                      lineHeight: "1.6",
                      color: "#555",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: extractFirstTwoSentencesOfFirstParagraph(
                        post.content
                      ),
                    }}
                  />

                  <div style={{ marginTop: "auto", textAlign: "center" }}>
                    <div
                      style={{
                        border: "1px solid #f06292",
                        borderRadius: "8px",
                        display: "inline-block",
                        backgroundColor: "#fff5f8",
                      }}
                    >
                      <Button
                        color="rose"
                        simple
                        href={`/blog-posts/${post.slug}`}
                        style={{ fontSize: "0.6rem", fontWeight: 400 }}
                      >
                        Devamını Oku
                      </Button>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </GridItem>
          ))}
        </GridContainer>
      </div>
    </div>
  );
}
